<template>
  <div class="admin_person_page">
    <div class="fr add_admin_person" @click="addCompany">添加单位</div>
    <table class="table mt20">
      <tr>
        <th v-for="tableTittle in tableTittles">{{tableTittle}}</th>
      </tr>
      <template v-for="(value,index) in companyData">
        <tr v-if="!value.flag">
          <td>{{value.company_name}}</td>
          <td><span style="cursor: pointer" @click="changeItem(index)">修改</span></td>
        </tr>
        <tr v-else>
          <td><input type="text" v-model="value.company_name"></td>
          <td>
            <span style="cursor: pointer" @click="saveItem(index)">保存</span>
            <span style="cursor: pointer" @click="cancelItem(index)">取消</span></td>
        </tr>
      </template>
    </table>
    <msgTips v-show="showFlag" @confirm="createCompany" @cancel="closeLayer" mheight="200" title="添加单位" >
      <div class="fill_group_row clearfix  w_half">
        <div class="form_group clearfix mb0">
          <label class="control_label h-l15">单位名称</label>
          <div class="form_control w_auto ">
            <input class="i_w260 form_input"  type="text" v-model="companyName">
          </div>
        </div>
      </div>
    </msgTips>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import msgTips from '../../components/layer/msgTips'
  import toastTips from '../../components/layer/toastTips'
  export default{
    name:'adminCompany',
    components:{
      msgTips,
      toastTips
    },
    data () {
      return {
        tableTittles:['单位名称','操作'],
        companyData:[],
        toastContent:'',
        toast:false,
        originalCompanyData:'',
        companyName:'',
        showFlag:false
      }

    },
    mounted:function(){
      this.getCompanyList();
    },
    methods:{
      getCompanyList(){
        var that=this;
        axios.get('/admin/company/list',{

        }).then((response)=>{
          if(response.data.code == 22000){
            that.companyData = response.data.result.list;
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      changeItem (index) {
        this.originalCompanyData= JSON.stringify(this.companyData);
        this.$set(this.companyData[index],"flag",true);
      },
      saveItem(index){
        var that=this;
        axios.post('/admin/company/edit',qs.stringify({
          id:that.companyData[index].id,
          name:that.companyData[index].company_name
        })).then((response)=>{
          if(response.data.code == 22000){
            that.$set(that.companyData[index],'flag',false)
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      cancelItem(index){
        var oCom=JSON.parse(this.originalCompanyData);
        for(var key in this.companyData[index]){
          this.companyData[index][key]=oCom[index][key];
        }
        this.companyData[index].flag=false;
      },
      addCompany () {
        this.showFlag=true;
      },
      createCompany(){
        var that=this;
        if(!that.companyName){
          that.toast=true;
          that.toastContent='请填写公司名称';
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
          return false;
        }
        axios.post('/admin/company/add',qs.stringify(
          {
            company_name:this.companyName
          }
        )).then((response)=>{
          if(response.data.code==22000){
            this.closeLayer();
            this.getCompanyList();
          }else if(response.data.code==50001){
            window.location.href='/#/login'
          }else{
            that.toast=true;
            that.toastContent=response.data.message;
            setTimeout(function(){
              that.toast=false;
              that.toastContent='';
            },3000)
          }
        })
      },
      closeLayer () {
        this.showFlag=false;
      }
    },
    watch:{
    }
  }
</script>
<style lang="less">
  .add_admin_person{
    position: absolute;
    top:20px;
    right:0;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/power_set/adminCompany.vue